export const MessageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66684 12.6664H5.3335C2.66683 12.6664 1.3335 11.9997 1.3335 8.66635V5.33301C1.3335 2.66634 2.66683 1.33301 5.3335 1.33301H10.6668C13.3335 1.33301 14.6668 2.66634 14.6668 5.33301V8.66635C14.6668 11.333 13.3335 12.6664 10.6668 12.6664H10.3335C10.1268 12.6664 9.92684 12.7664 9.80017 12.933L8.80017 14.2664C8.36017 14.853 7.64017 14.853 7.20017 14.2664L6.20017 12.933C6.0935 12.7864 5.84684 12.6664 5.66684 12.6664Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 5.33301H11.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 8.66699H8.66651"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
